<template>
  <v-container>
    <div class="page-content">
      <div class="page-content-head">
        <h4 class="title-page">
          Обратная связь
        </h4>
        <div class="indicator-3">
          <span class="green"></span>
          <span class="yellow"></span>
          <span class="redhead"></span>
        </div>
      </div>
      <div class="page-content-body">
        <h2>Новое обращение</h2>
        <div class="feedback-form">
          <form @submit.prevent="createFeedback">
            <v-row>
              <div class="col s6">
                <label>Данные заявителя:</label>
                <div class="input-field">
                  <input
                    v-model="firstName"
                    type="text"
                    placeholder="Ваше имя*"
                    required
                  />
                </div>
                <div class="input-field">
                  <input
                    v-model="secondName"
                    type="text"
                    placeholder="Ваша фамилия*"
                    required
                  />
                </div>
                <div class="input-field">
                  <input
                    v-model="patronymic"
                    type="text"
                    placeholder="Ваше отчество"
                  />
                </div>
                <div class="input-field">
                  <input
                    v-model="phone"
                    type="text"
                    placeholder="Ваш телефон"
                  />
                </div>
                <div class="input-field">
                  <input
                    v-model="email"
                    type="email"
                    placeholder="Ваш e-mail*"
                    required
                  />
                </div>
              </div>
              <div class="col s6">
                <label>Обращение:</label>
                <div class="input-field select-def">
                  <v-select
                    v-model="selectedGoal"
                    :items="goal"
                    item-value="id"
                    item-text="transName"
                    persistent-hint
                    @change="changeGoal"
                    label="Выберите ЦУР"
                  ></v-select>
                </div>
                <div class="input-field">
                  <v-textarea
                    v-model="message"
                    class="materialize-textarea"
                    clearable
                    label="Ваше сообщение *"
                    required
                  ></v-textarea>
                </div>
              </div>
            </v-row>
            <v-row>
              <div class="col s12">
                <div class="input-action">
                  <v-btn
                    type="submit"
                    class="btn green darken-2"
                  >
                    Отправить
                  </v-btn>
                  <v-btn
                    class="btn default"
                    @click="clearForm"
                  >
                    Очистить
                  </v-btn>
                </div>
              </div>
            </v-row>
          </form>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import Feedback from '@/model/feedback'

  export default {
    name: 'Feedback',
    data: () => ({
      firstName: '',
      secondName: '',
      patronymic: '',
      phone: '',
      email: '',
      goal: [],
      selectedGoal: null,
      message: ''
    }),
    watch: {
      // при изменениях маршрута запрашиваем данные снова
      '$route': 'fetchData'
    },
    created () {
      // загружаем данные, когда представление создано
      // и данные реактивно отслеживаются
      this.fetchData()
    },
    methods: {
      fetchData () {
        Feedback.getFeedbackData()
          .then((response) => {
            this.goal = response.data.refGoal
          })
          .catch((error) => {
          })
      },
      createFeedback () {
        const data = {
          firstName: this.firstName,
          secondName: this.secondName,
          patronymic: this.patronymic,
          phone: this.phone,
          email: this.email,
          goal: this.selectedGoal,
          message: this.message
        }
        try {
          Feedback.createFeedback(data)
            .then((response) => {
                const id = response.data.feedback
                this.$router.push({
                  name: 'success-feedback',
                  params: {id}
                })
            })
        } catch (error) {
        }
      },
      changeGoal (id) {
        this.selectedGoal = id
      },
      clearForm () {
        this.firstName = ''
        this.secondName = ''
        this.patronymic = ''
        this.phone = ''
        this.email = ''
        this.selectedGoal = null
        this.message = ''
      }
    },
    mounted () {
      this.fetchData()
    }
  }
</script>
